export default function isStringParsableToInt(value: string) {
    return /^\d+$/.test(value);
}